export default __webpack_public_path__ + "assets/images/speak-cloud.94cf63b27bbece3216f2921a8f2bc11e.svg";